import React, { Component } from "react";
import { Button, Spinner, OverlayTrigger } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Avatar from "react-avatar";
import EditUserProfileForm from './EditUserProfileForm';
import EditUserRoleForm from './EditUserRoleForm';
import DeleteConfirmForm from './DeleteConfirmForm';
import truncateString from "../../utils/truncateString";
import "./UserCard.scss";

const ReactSwal = withReactContent(Swal);

class UserCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false
    };
  }

  onEditUserClick = () => {
    if (this.props.isOwner) {
      this.props.onClick();
      return;
    }

    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <EditUserProfileForm
          onClose={ReactSwal.clickConfirm}
          onAddContentType={this.props.addContentType}
        />
      )
    })
    .then(result => {
      if (result.value) {
      }
    });
  }

  onDeleteUserClick = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <DeleteConfirmForm
          type="user"
          onClose={ReactSwal.clickCancel}
          onConfirm={ReactSwal.clickConfirm}
        />
      )
    })
    .then(result => {
      if (result.value) {
        this.setState({ isLoading: true });
        this.props.deleteUser(this.props.user.userId, this.props.user.email);
      }
    });
  }

  onChangeRoleClick = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <EditUserRoleForm
          onClose={ReactSwal.clickConfirm}
          updateUserRole={this.props.updateUserRole}
          user={this.props.user}
        />
      )
    })
    .then(result => {
      if (result.value) {
      }
    });
  }

  renderTooltip = (props, key) => {
    const { style, ...rest } = props;
    delete rest.outOfBoundaries;

    if (rest.scheduleUpdate) {
      delete rest.scheduleUpdate;
    }

    if (rest.scheduleupdate) {
      delete rest.scheduleupdate;
    }

    delete rest.arrowProps;
  
    return (
      <div
        {...rest}
        show={rest.show.toString()}
        style={{
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          padding: '2px 10px',
          color: 'white',
          borderRadius: 3,
          ...style,
        }}
      >
        {key}
      </div>
    );
  };

  render() {
    return (
      <div className="user-card">
        <OverlayTrigger
          placement="right-start"
          delay={{ show: 250, hide: 400 }}
          overlay={props => this.renderTooltip(props, this.props.user.isConfirmed ? 'ACTIVE' : 'INVITED')}
        >
          <div className={`user-status${this.props.user.isConfirmed ? ' active' : ' invited'}`} />
        </OverlayTrigger>
        <div className="user-detail">
            <Avatar
              name={this.props.user.name}
              size={40}
              round={true}
              color="#63b3ed"
              fgColor="white"
              className="mr-2"
              src={this.props.user.imageUrl}
            />
          <div className="user-info">
            <span className="user-name">{truncateString(this.props.user.name, 20)}</span>
            <span className="user-email"><a href={`mailto:${this.props.user.email}`}>{truncateString(this.props.user.email, 22)}</a></span>
            <span className="user-role">{this.props.user.role}</span>
          </div>
        </div>
        <div className="buttons">
          {!this.props.isOwner && this.props.isAdmin && <Button variant="outline-danger" size="sm"  onClick={this.onChangeRoleClick}>CHANGE ROLE</Button>}
          {this.props.isOwner && <Button variant="outline-danger" size="sm" onClick={this.onEditUserClick}>EDIT</Button>}
          {!this.props.isOwner && this.props.isAdmin &&
            <Button
              variant="outline-danger"
              size="sm"
              onClick={this.onDeleteUserClick}
              disabled={this.state.isLoading || !this.props.user.userId}
            >
              {this.state.isLoading || !this.props.user.userId ?
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                /> : 'DELETE'
              }
            </Button>
          }
        </div>
      </div>
    );
  }
}

export default UserCard;
